import React from 'react'
import { ReactComponent as ChatIcon } from './assets/header.svg'
import widgetStyles from './assets/widget.module.scss'
import Icon, { IconType } from '../Icon'

const DrawerHeader = props => (

  <div
    className={widgetStyles['header']}
  >

    <ChatIcon
      className={widgetStyles['icon']}
    />
    <p
      className={widgetStyles['title']}
    >
        Presenter support chat
    </p>

    <div
      className={widgetStyles['button']}
      onClick={props.onClose}
    >
      <Icon
        className={widgetStyles['close']}
        data-bdd="support-panel-close"
        name={IconType.iconName.close}
      />
    </div>

  </div>

)

export default DrawerHeader
